// extracted by mini-css-extract-plugin
module.exports = {"stage":"Stage_stage__CYnIt"};